<template>
    <footer>
      <span>© New Orleans Saints. All Rights Reserved</span>
      <a href="https://www.neworleanssaints.com/privacypolicy" target="_blank">Privacy Policy</a>
      <a href="https://www.neworleanssaints.com/privacypolicy#interestbasedadvertising" target="_blank">Ad Choices</a>
      <a href="https://privacyportal.onetrust.com/webform/46acd508-0e8d-40cd-af22-1a8bdfa6da60/224a3598-1b25-497d-9273-be255f55461c" target="_blank">Your Privacy Choices</a>
      <a id="ot-sdk-btn" class="ot-sdk-show-settings">Cookie Settings</a>
    </footer>
</template>

<script>

export default {
  name: 'MainNav',
  methods: { 
           scrollToTop() {
                window.scrollTo(0,0);
           }
   }
}

</script>

<style>
footer {
  color:white;
  min-height:35px;
  display:flex;
  flex-direction:column;
  justify-content: center;
  align-items: center;
  font-size:12px;
}

footer a {
  color:white;
}



#ot-sdk-btn.ot-sdk-show-settings, #ot-sdk-btn.optanon-show-settings {

    font-size: 12px!important;
    text-decoration: none!important;
    color: #ffffff!important;
    background: transparent;
    border: none!important;
    padding: 0!important;
    text-decoration: underline!important;
    font-family: Avenir, Helvetica, Arial, sans-serif!important;
    line-height: normal!important;
}

#ot-sdk-btn.ot-sdk-show-settings:hover, #ot-sdk-btn.optanon-show-settings:hover {
    color: #fff;
    background-color: transparent!important;
}



@media(min-width:500px) {
  footer {
    flex-direction:row;
  }
  footer a {
    margin-left:6px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/MainFooter.vue